module.exports = __webpack_public_path__ + "static/media/gears.943a1f14.jpg";